import { useEvent } from "react-use";

function useParentMessages({ setForm, setUser }: { setForm: (form: any) => void; setUser: (user: any) => void }) {
  useEvent("message", (event) => {
    if (!event.data) return;
    const { type, payload } = event.data;
    if (type === "feedback") {
      setForm(payload);
    } else if (type === "user") {
      setUser(payload);
    }
  });
}

export default useParentMessages;
